module.exports = __webpack_public_path__ + "img/blueLocation.8d7797ae.svg";